import serverName from '../serverName';
export default function Footer() {
    return (
        <footer className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 py-8 text-sm text-white/50">
                © {new Date().getFullYear()} {serverName} RP
            </div>
        </footer>
    )
}